// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.9.1",
  date: "2026-09-17T14:02:28.703Z",
  gitInfo: {
    dirty: false,
    raw: "8dd4afb7c",
    hash: "8dd4afb7c",
    distance: null,
    tag: null,
    semver: null,
    suffix: "8dd4afb7c",
    semverString: null
  }
};
/* tslint:enable */
